import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultKSK2090_R01DetailDto, defaultKSK2090_R01HeaderDto, KSK2090_R01DetailDto, KSK2090_R01HeaderDto } from './Dto_KSK2090_R01';
import { showWarning } from 'src/utils/toast/toastUtil';


export interface KSK2090_R01Filter {
	prntItemcd: string;
	prntItemnm: string;
}
export interface Store_KSK2090_R01 {
	KSK2090_R01Filter: KSK2090_R01Filter;
	KSK2090_R01PastFilter: KSK2090_R01Filter;
	setKSK2090_R01Filter: (filter: Partial<Store_KSK2090_R01['KSK2090_R01Filter']>) => void;
	setKSK2090_R01PastFilter: (filter: Store_KSK2090_R01['KSK2090_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	KSK2090_R01List: KSK2090_R01HeaderDto[];
	setKSK2090_R01List: (salesList: KSK2090_R01HeaderDto[]) => void;

	editKSK2090_R01: KSK2090_R01HeaderDto | null;
	setEditKSK2090_R01: (editSale: KSK2090_R01HeaderDto | null) => void;

	selectedKSK2090_R01: KSK2090_R01HeaderDto | undefined;
	setSelectedKSK2090_R01: (data: KSK2090_R01HeaderDto | undefined) => void;
	initSelectedKSK2090_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2090_R01DetailList: string[];
	setDeletedKSK2090_R01DetailList: (idList: string[]) => void;
	addDeletedKSK2090_R01DetailList: (idList: string[]) => void;
	removeDeletedKSK2090_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	KSK2090_R01DetailList: KSK2090_R01DetailDto[];
	setKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[]) => void;
	insertKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[], index?: number) => void;
	removeKSK2090_R01DetailList: (index: number) => void;
	updateKSK2090_R01DetailList: (index: number, data: KSK2090_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedKSK2090_R01DetailList: string[];
	setSelectedKSK2090_R01DetailList: (idList: string[]) => void;
	addSelectedKSK2090_R01DetailList: (idList: string[]) => void;
	removeSelectedKSK2090_R01DetailList: (idList?: string[]) => void;
	initSelectedKSK2090_R01DetailList: () => void;

	editKSK2090_R01Detail: KSK2090_R01DetailDto | null;
	setEditKSK2090_R01Detail: (editDetail: KSK2090_R01DetailDto | null) => void;

	originalKSK2090_R01DetailList: KSK2090_R01DetailDto[];
	setOriginalKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;			setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultKSK2090_R01Filter : KSK2090_R01Filter = {
	prntItemcd: '',
	prntItemnm: '',
};

export const useKSK2090_R01Store = create<Store_KSK2090_R01>((set) => ({
	KSK2090_R01Filter: defaultKSK2090_R01Filter,
	KSK2090_R01PastFilter: defaultKSK2090_R01Filter,
	setKSK2090_R01Filter: (update) => set((state) => ({
		KSK2090_R01Filter: {
			...state.KSK2090_R01Filter,
			...update
		}
	})),
	setKSK2090_R01PastFilter: (filter: Store_KSK2090_R01['KSK2090_R01PastFilter']) => set((state) => {
		return {
			...state,
			KSK2090_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	KSK2090_R01List: [],
	setKSK2090_R01List: (salesList: KSK2090_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			KSK2090_R01List: salesList
		}
	}),

	editKSK2090_R01: defaultKSK2090_R01HeaderDto,
	setEditKSK2090_R01: (editSale: KSK2090_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editKSK2090_R01: editSale
		}
	}),

	selectedKSK2090_R01: undefined,
	
	setSelectedKSK2090_R01: (data: KSK2090_R01HeaderDto | undefined) => set((state) => {

		return { 
			...state,
			selectedKSK2090_R01: data,
			selectedKSK2090_R01DetailList: [],
			deletedKSK2090_R01DetailList: [],
		};
	}),
	initSelectedKSK2090_R01: () => set({ selectedKSK2090_R01: undefined, editKSK2090_R01: defaultKSK2090_R01HeaderDto, editKSK2090_R01Detail: defaultKSK2090_R01DetailDto, KSK2090_R01DetailList: [] }),

	// ====== 매출 상세(디테일) 데이터 ======
	KSK2090_R01DetailList: [],
	setKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[]) => set((state) => {
		let newList: KSK2090_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2090_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2090_R01DetailList: newList
		}
	}),
	insertKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[], index?: number) => set((state) => {
		let newKSK2090_R01DetailList = [...state.KSK2090_R01DetailList];

		let targetRowData = newKSK2090_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2090_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newKSK2090_R01DetailList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2090_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newKSK2090_R01DetailList에 대체
		newKSK2090_R01DetailList = newKSK2090_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2090_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2090_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2090_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK2090_R01DetailList.push(...newData);
		}
		
		return {
			...state,
			KSK2090_R01DetailList: newKSK2090_R01DetailList
		}
	}),
	removeKSK2090_R01DetailList: (index: number) => set((state) => {
		const newKSK2090_R01DetailList = [...state.KSK2090_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2090_R01DetailList: newKSK2090_R01DetailList
		}
	}),
	updateKSK2090_R01DetailList: (valueIndex: number, data: KSK2090_R01DetailDto) => set((state) => {
		const _KSK2090_R01DetailList = state.KSK2090_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			KSK2090_R01DetailList: _KSK2090_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2090_R01DetailList: [],
	setDeletedKSK2090_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2090_R01DetailList: idList
		}
	}),
	addDeletedKSK2090_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedKSK2090_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2090_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2090_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK2090_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedKSK2090_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2090_R01DetailList: [...state.deletedKSK2090_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2090_R01DetailList: [],
	setSelectedKSK2090_R01DetailList: (idList: string[]) => set((state) => {

		//맨 마지막으로 선택한 행을 editKSK2090_R01Detail로 설정
		const lastRow = state.KSK2090_R01DetailList[state.KSK2090_R01DetailList.length - 1];

		return {
			...state,
			selectedKSK2090_R01DetailList: idList,
			editKSK2090_R01Detail: lastRow
		}
	}),
	addSelectedKSK2090_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedKSK2090_R01DetailList = [...state.selectedKSK2090_R01DetailList];
		if(idList.length > 0) {
			_selectedKSK2090_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedKSK2090_R01DetailList: _selectedKSK2090_R01DetailList
		}
	}),
	removeSelectedKSK2090_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2090_R01DetailList: [...state.selectedKSK2090_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2090_R01DetailList: () => set({ selectedKSK2090_R01DetailList: [], editKSK2090_R01Detail: defaultKSK2090_R01DetailDto }),

	editKSK2090_R01Detail: defaultKSK2090_R01DetailDto,
	setEditKSK2090_R01Detail: (editDetail: KSK2090_R01DetailDto | null) => set((state) => {

		let newDetailList = state.KSK2090_R01DetailList;

		// editDetail이 존재하고, valueIndex가 유효한 경우에만 detailList를 업데이트합니다.
		if (editDetail && editDetail.valueIndex) {
			newDetailList = state.KSK2090_R01DetailList.map(item =>
				item.valueIndex === editDetail.valueIndex
					? { 
						...item,
						isModified: editDetail.isModified
					} // 기존 item 데이터에 변경된 editDetail 데이터를 덮어씁니다.
					: item
			);
		}

		return {
			...state,
			KSK2090_R01DetailList: newDetailList, // 업데이트된 새 배열로 상태를 교체합니다.
			editKSK2090_R01Detail: editDetail
		}
	}),

	originalKSK2090_R01DetailList: [],
	setOriginalKSK2090_R01DetailList: (data: KSK2090_R01DetailDto[]) => set((state) => {
		let newList: KSK2090_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2090_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2090_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,		setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),


	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		KSK2090_R01Filter: defaultKSK2090_R01Filter,
		KSK2090_R01PastFilter: defaultKSK2090_R01Filter,
		KSK2090_R01List: [],
		selectedKSK2090_R01: undefined,
		KSK2090_R01DetailList: [],
		deletedKSK2090_R01DetailList: [],
		selectedKSK2090_R01DetailList: [],
		editKSK2090_R01: defaultKSK2090_R01HeaderDto,
		editKSK2090_R01Detail: defaultKSK2090_R01DetailDto,
		allCount: 0,
		
	})),

}));
